export class DCTreeConstants {
    private static _ENTITY_TO_QUERY_PARAMETERS_MAP: Object = {
        'vcenter': 'parentType=vcenter&format=tree',
        'folder': 'parentType=folder&entityType=folder&format=tree',
        'datacenter': 'entityType=host$folder,host$cluster,host$computeResource&parentType=datacenter&format=tree',
        'cluster': 'entityType=Resources$resourcePool&parentType=cluster&format=tree',
        'computeResource': 'entityType=Resources$resourcePool,Resources$vm&parentType=computeResource&format=tree',
        'resourcePool': 'entityType=resourcePool&parentType=resourcePool&format=tree'
    };
    public static getChildrenQueryParameters(entity: string): string {
       return DCTreeConstants._ENTITY_TO_QUERY_PARAMETERS_MAP[entity];
    }
}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dc-tree/dc-tree-constants.ts